import { Row, Col, Spacer } from '@amzn/stencil-react-components/layout';
import { H3, Text } from '@amzn/stencil-react-components/text';
import React from 'react';
import Img1 from '../../img/WelcomeSlides/slide3-img1.png';

const Slide3 = () => {
  return (
    <Col alignItems="center">
      <H3>Nudges help deliver results</H3>
      <Spacer height={12} />
      <Text>
        Bubble: Drive Ingenii adoption for your org, Send Newsletters, Drive montor/mentee program,
        Share bite-sized resources with managers.
      </Text>

      <Row flex="1" alignItems="center">
        <Col>
          <img async src={Img1} width={'100%'} />
        </Col>
      </Row>
    </Col>
  );
};

export default Slide3;
